type GetWorkboardClickedRecordIdOptions = {
  interactiveColumnIds: Set<string>;
  ignoreCellClassNames?: string[];
};

const getWorkboardClickedRecordId = (
  event: React.MouseEvent<HTMLDivElement>,
  { interactiveColumnIds, ignoreCellClassNames = [] }: GetWorkboardClickedRecordIdOptions
): string | null => {
  const target = event.target as HTMLElement | null;
  const cell = target?.closest('td') as HTMLTableCellElement | null;
  if (!cell) {
    return null;
  }
  if (cell.classList.contains('table-header') || cell.classList.contains('legend')) {
    return null;
  }
  if (ignoreCellClassNames.some(className => cell.classList.contains(className))) {
    return null;
  }

  const columnRef = cell.getAttribute('data-column-ref') ?? '';
  if (interactiveColumnIds.has(columnRef) || cell.classList.contains('workboard-interactive-cell')) {
    return null;
  }

  return cell.getAttribute('data-alias');
};

export default getWorkboardClickedRecordId;
